/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { UIChart } from 'primeng/chart';
import { LANGUAGES } from 'src/app/conf/languages';
import { AccessoryPower, BoardPower } from 'src/app/model/device-bus';
import { AppState } from 'src/app/store/app.reducer';
import * as UserActions from 'src/app/store/user/user.actions';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { Observable, Subscription } from 'rxjs';
import { User } from 'src/app/model/user';
import { selectUser } from 'src/app/store/user/user.selector';
import { StandardPageLayout } from '../shared/stdlayoutlib/classes.stdlayoutlib';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';

@Component({
	selector: 'app-green-power2',
	templateUrl: './green-power2.component.html',
	providers: [ConfirmationService, DialogService]
})
export class GreenPower2Component implements OnInit, OnDestroy {
	@ViewChild('total') chart: UIChart;

	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;

	enableGreenPower: boolean;

	listBus: BoardPower[];
	busSelect: BoardPower | undefined;

	listGateway: AccessoryPower[];
	listFotocelluleBus: AccessoryPower[];
	listSelettoriBus: AccessoryPower[];
	listInterfaccieBus: AccessoryPower[];
	listLampeggiantiBus: AccessoryPower[];
	listFotocell: AccessoryPower[];
	listSelR: AccessoryPower[];
	listLampeggiantiOld: AccessoryPower[];
	listSchede: AccessoryPower[];
	valuePower = [];
	valueGreenPower = [];
	valueCalcPower = [];
	valueCalcPowerBus = [];


	maxPowerNorm: number;
	maxPowerBus: number;

	maxGateway: number;
	maxSchede: number;
	maxFotocelluleBus: number;
	maxSelettoriBus: number;
	maxInterfaccieBus: number;
	maxLampeggiantiBus: number;
	maxFotocelluleOld: number;
	maxSelettoriOld: number;
	maxLampeggiantiOld: number;

	totalBoard: number;
	totalSchede: number;
	totalGateway: number;
	totalFotocelluleBus: number;
	totalSelettoriBus: number;
	totalInterfaccieBus: number;
	totalLampeggiantiBus: number;
	totalFotocelluleOld: number;
	totalSelettoriOld: number;
	totalLampeggiantiOld: number;


	// POWER
	totalLoadBoard: number;
	totalLoadGateway: number;
	totalLoadSchede: number;
	totalLoadFotocelluleBus: number;
	totalLoadSelettoriBus: number;
	totalLoadInterfaccieBus: number;
	totalLoadLampeggiantiBus: number;
	totalLoadFotocelluleOld: number;
	totalLoadSelettoriOld: number;
	totalLoadLampeggiantiOld: number;
	totalPower: number;
	totalPowerBus: number;

	totalLoadBoardPercentage: number;
	totalLoadGatewayPercentage: number;
	totalLoadSchedePercentage: number;
	totalLoadFotocelluleBusPercentage: number;
	totalLoadSelettoriBusPercentage: number;
	totalLoadInterfaccieBusPercentage: number;
	totalLoadLampeggiantiBusPercentage: number;
	totalLoadFotocelluleOldPercentage: number;
	totalLoadSelettoriOldPercentage: number;
	totalLoadLampeggiantiOldPercentage: number;
	totalLoadBusPercentage: number;
	// POWER


	// GREEN POWER
	totalGreenLoadBoard: number;
	totalGreenLoadGateway: number;
	totalGreenLoadSchede: number;
	totalGreenLoadFotocelluleBus: number;
	totalGreenLoadSelettoriBus: number;
	totalGreenLoadInterfaccieBus: number;
	totalGreenLoadLampeggiantiBus: number;
	totalGreenLoadFotocelluleOld: number;
	totalGreenLoadSelettoriOld: number;
	totalGreenLoadLampeggiantiOld: number;
	totalGreenPower: number;
	totalGreenPowerBus: number;

	totalGreenLoadBoardPercentage: number;
	totalGreenLoadGatewayPercentage: number;
	totalGreenLoadSchedePercentage: number;
	totalGreenLoadFotocelluleBusPercentage: number;
	totalGreenLoadSelettoriBusPercentage: number;
	totalGreenLoadInterfaccieBusPercentage: number;
	totalGreenLoadLampeggiantiBusPercentage: number;
	totalGreenLoadFotocelluleOldPercentage: number;
	totalGreenLoadSelettoriOldPercentage: number;
	totalGreenLoadLampeggiantiOldPercentage: number;
	totalGreenLoadBusPercentage: number;
	// GREEN POWER


	totalLoadBoardPercentageLimitGreenPower: number;
	totalLoadGatewayPercentageLimitGreenPower: number;
	totalLoadSchedePercentageLimitGreenPower: number;
	totalLoadFotocelluleBusPercentageLimitGreenPower: number;
	totalLoadSelettoriBusPercentageLimitGreenPower: number;
	totalLoadInterfaccieBusPercentageLimitGreenPower: number;
	totalLoadLampeggiantiBusPercentageLimitGreenPower: number;
	totalLoadFotocelluleOldPercentageLimitGreenPower: number;
	totalLoadSelettoriOldPercentageLimitGreenPower: number;
	totalLoadLampeggiantiOldPercentageLimitGreenPower: number;


	totalLoadBoardPercentageNorm: number;
	totalLoadGatewayPercentageNorm: number;
	totalLoadSchedePercentageNorm: number;
	totalLoadFotocelluleBusPercentageNorm: number;
	totalLoadSelettoriBusPercentageNorm: number;
	totalLoadInterfaccieBusPercentageNorm: number;
	totalLoadLampeggiantiBusPercentageNorm: number;
	totalLoadFotocelluleOldPercentageNorm: number;
	totalLoadSelettoriOldPercentageNorm: number;
	totalLoadLampeggiantiOldPercentageNorm: number;
	totalLoadBusPercentageNorm: number;


	totalLoadFotocelluleBusPercentageBus: number;
	totalLoadSelettoriBusPercentageBus: number;
	totalLoadInterfaccieBusPercentageBus: number;
	totalLoadLampeggiantiBusPercentageBus: number;
	statusPower: number;
	statusLimitGreenPower: number;
	statusPowerNorm: number;
	statusPowerBus: number;

	/*ZN7 = new BoardPower(1, 'ZN7', 40, 0.5, true, 5, 0.3, 2, 0,
		1, 1, 0, 0, 0, 0, 8, 2, 2);*/
	/*ZN7 = {
		id: 1, name: 'ZN7', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.3, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 2, maxLampeggiantiOld: 2
	}
	ZBX7N = new BoardPower(2, 'ZBX7N', 20, 0.5, true, 5, 0.3, 2, 0,
		1, 1, 0, 0, 0, 0, 8, 2, 2);
		ZBX7N = {
			id: 2, name: 'ZN7', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
			powerGreen: 0.3, maxPowerGreen: 2.3, cxn: 0,
			maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
			maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 2, maxLampeggiantiOld: 2
		}
	ZL57 = new BoardPower(3, 'ZL57', 40, 0.8, true, 5, 0.3, 2, 0,
		1, 1, 0, 0, 0, 0, 8, 2, 2);
		ZN7 = {
			id: 1, name: 'ZN7', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
			powerGreen: 0.3, maxPowerGreen: 2.3, cxn: 0,
			maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
			maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 2, maxLampeggiantiOld: 2
		}
	ZLX24 = new BoardPower(4, 'ZLX24', 40, 0.5, true, 3, 0.3, 2, 15,
		1, 1, 8, 8, 2, 2, 8, 0, 2);
		ZN7 = {
			id: 1, name: 'ZN7', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
			powerGreen: 0.3, maxPowerGreen: 2.3, cxn: 0,
			maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
			maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 2, maxLampeggiantiOld: 2
		}
	ZLX230 = new BoardPower(5, 'ZLX230', 12, 0.8, true, 0.8, 0.3, 0, 15,
		1, 1, 8, 8, 2, 2, 0, 0, 0);
		ZN7 = {
			id: 1, name: 'ZN7', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
			powerGreen: 0.3, maxPowerGreen: 2.3, cxn: 0,
			maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
			maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 2, maxLampeggiantiOld: 2
		}*/
	BX704_ZBX7N = {
		id: 1, name: 'BX704/708-ZBX7N', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	BX608_ZBX6N = {
		id: 2, name: 'BX608-ZBX6N', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 2, maxLampeggiantiOld: 2
	}
	BKV_ZN7 = {
		id: 3, name: 'BKV-ZN7', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	BKV_RAPID_ZN7 = {
		id: 4, name: 'BKV RAPID-ZN7', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	ZL65 = {
		id: 5, name: 'ZL65', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	FA7024CB_ZL65 = {
		id: 6, name: 'FA7024CB/FST23DLC-ZL65', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	FTX20DGC_ZL65 = {
		id: 7, name: 'FTX20DGC/FTX20DLC-ZL65', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	VER_ZL57 = {
		id: 8, name: 'VER PLUS-ZL57', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	ZLX24M = {
		id: 9, name: 'ZLX24M', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 15,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 8, maxSelettoriBus: 8, maxInterfaccieBus: 2,
		maxLampeggiantiBus: 2, maxFotocelluleOld: 8, maxSelettoriOld: 0, maxLampeggiantiOld: 2
	}
	ZLX24S = {
		id: 10, name: 'ZLX24S', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 15,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 8, maxSelettoriBus: 8, maxInterfaccieBus: 2,
		maxLampeggiantiBus: 2, maxFotocelluleOld: 8, maxSelettoriOld: 0, maxLampeggiantiOld: 2
	}
	ZM3E = {
		id: 11, name: 'ZM3E', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	ZF1N = {
		id: 12, name: 'ZF1N', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	FA70230CB_ZF1N = {
		id: 13, name: 'FA70230CB-ZF1N', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	EMEGA_ZL43 = {
		id: 14, name: 'EMEGA-ZL43', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	BKX_ZBB3 = {
		id: 15, name: 'BKX-ZBB3', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 15,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 8, maxSelettoriBus: 8, maxInterfaccieBus: 2,
		maxLampeggiantiBus: 2, maxFotocelluleOld: 8, maxSelettoriOld: 0, maxLampeggiantiOld: 2
	}
	ZLB24S = {
		id: 16, name: 'ZLB24S', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 1, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	//BX704_ZBX7N
	//BX608_ZBX6N
	//BKV_ZN7
	//BKV_RAPID_ZN7
	//ZL65
	//FA7024CB_ZL65
	//FTX20DGC_ZL65
	//VER_ZL57
	//ZLX24M
	//ZLX24S
	//ZM3E
	//ZF1N
	//FA70230CB_ZF1N
	//EMEGA_ZL43
	//BKX_ZBB3
	//ZLB24S

	browserDeviceScreen = 960;

	visibleCameInfo = true;


	totalChart: any;
	totalOptions: any;

	guest = true;

	/*doughnutChartLabels: Label[] = [];
	doughnutChartData: MultiDataSet = [[]];
	doughnutChartType: ChartType = 'doughnut';
	colors: Color[] = [{backgroundColor: ['orange', 'green', 'blue', 'pink', 'grey']}];*/

	// design
	acceptButtonStyle: string;
	rejectButtonStyle: string;
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MIN_MD_WIDTH_EXT = 670;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_COL4 = 1530;
	MIN_WIDTH_MX7 = 1700;

	doughnutChartOptions = {
		legend: {
			display: true,
			position: 'bottom',
			onClick: (e) => e.stopPropagation(),
		},
		tooltips: {
			callbacks: {
				label: (tooltipItem) => this.tooltips(tooltipItem),
				title: () => null,
			}
		},
	};

	constructor(
		private route: ActivatedRoute,
		private translate: TranslateService,
		private store: Store<AppState>,
		public dialogService: DialogService,
		public confirmationService: ConfirmationService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.user$ = this.store.select(selectUser);
	}

	ngOnDestroy(): void {
		this.userSub?.unsubscribe();
	}

	ngOnInit() {
		this.enableGreenPower = true;
		this.userSub = this.user$?.subscribe(currentUser => {
			if (currentUser !== undefined && currentUser.Email !== undefined && currentUser.Email !== '') {
				this.guest = false;
			}
		});
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'BUS_PAGE_TITLE'
		}));
		const lang = this.route.snapshot.queryParamMap.get('language');
		const langVal = LANGUAGES.find(l => l.code === lang);
		if (langVal !== undefined) {
			this.store.dispatch(UserActions.setCurrentLang({ lang: langVal }));
			if (langVal.code !== this.translate.currentLang && localStorage != null) {
				window.location.reload();
			}
		}

		const doughnutChartLabels = [this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalFotocelluleBus + '): ' + this.totalLoadFotocelluleBusPercentage + '%'];
		doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS') + ' (' + this.totalSelettoriBus + '): ' + this.totalLoadSelettoriBusPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_INTERFACES') + ' (' + this.totalInterfaccieBus + '): ' + this.totalLoadInterfaccieBusPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_FLASHING') + ' (' + this.totalLampeggiantiBus + '): ' + this.totalLoadLampeggiantiBusPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_AVAILABLE') + ': ' + 100 + '%');

		const documentStyle = getComputedStyle(document.documentElement);

		this.totalChart = {
			labels: doughnutChartLabels,
			datasets: [
				{
					// label: [this.translate.instant('BUS_PHOTOCELLS'),'BUS_SELECTORS','BUS_INTERFACES','BUS_FLASHING','BUS_AVAILABLE'],
					data: [0, 0, 0, 0, 100],
					backgroundColor: [documentStyle.getPropertyValue('--yellow-600'), documentStyle.getPropertyValue('--green-600'), documentStyle.getPropertyValue('--blue-600'), documentStyle.getPropertyValue('--purple-600'), documentStyle.getPropertyValue('--blueGrey-600')],
					borderWidth: 0,
				},
			],
		};

		this.totalOptions = {
			plugins: {
				legend: {
					display: false,
					position: 'right',
				},
			},
			responsive: true,
			cutout: '70%',
			animation: false
		};

		this.browserDeviceScreen = window.screen.width;
		this.listBus = [];
		this.listBus.push(this.BX704_ZBX7N);
		this.listBus.push(this.BX608_ZBX6N);
		this.listBus.push(this.BKV_ZN7);
		this.listBus.push(this.BKV_RAPID_ZN7);
		this.listBus.push(this.ZL65);
		this.listBus.push(this.FA7024CB_ZL65);
		this.listBus.push(this.FTX20DGC_ZL65);
		this.listBus.push(this.VER_ZL57);
		this.listBus.push(this.ZLX24M);
		this.listBus.push(this.ZLX24S);
		this.listBus.push(this.ZM3E);
		this.listBus.push(this.ZF1N);
		this.listBus.push(this.FA70230CB_ZF1N);
		this.listBus.push(this.EMEGA_ZL43);
		this.listBus.push(this.BKX_ZBB3);
		this.listBus.push(this.ZLB24S);
		this.busSelect = this.listBus[0];


		this.listGateway = [];
		this.listGateway.push(new AccessoryPower(1, 'Gateway', 'BUS_CAME_KEY', 0.5, 0.7, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listGateway.push(new AccessoryPower(2, 'Gateway', 'BUS_GATEWAY_WIFI', 0.5, 1, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listGateway.push(new AccessoryPower(3, 'Gateway', 'BUS_SLAVE', 0.5, 0.5, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listGateway.push(new AccessoryPower(4, 'Gateway', 'BUS_RGSM', 4, 4, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listGateway.push(new AccessoryPower(5, 'Gateway', 'BUS_GATEWAY_4G', 4, 4, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.listFotocelluleBus = [];
		this.listFotocelluleBus.push(new AccessoryPower(1, 'Fotocellule Bus', 'BUS_CALC_PHO_DLX_BUS_DXR_BUS', 0.35, 0.35, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		/*this.listFotocelluleBus.push(new AccessoryPower(2, 'Fotocellule Bus', 'BUS_CALC_PHO_DXR_BUS', 0.35, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));*/

		this.listSelettoriBus = [];
		this.listSelettoriBus.push(new AccessoryPower(1, 'Selettori Bus', 'BUS_CALC_SEL_KEYPAD', 0.35, 0.35, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSelettoriBus.push(new AccessoryPower(2, 'Selettori Bus', 'BUS_CALC_SEL_RFID_TRA', 0.35, 0.35, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSelettoriBus.push(new AccessoryPower(3, 'Selettori Bus', 'BUS_CALC_SEL_MIFARE_TRA', 1, 1, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSelettoriBus.push(new AccessoryPower(4, 'Selettori Bus', 'BUS_CALC_SEL_BLE', 1, 1, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSelettoriBus.push(new AccessoryPower(5, 'Selettori Bus', 'BUS_CALC_SEL_KEY_SEL', 0.35, 0.35, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.listInterfaccieBus = [];
		this.listInterfaccieBus.push(new AccessoryPower(1, 'Interfacce Bus', 'BUS_CALC_INT_MODULE', 0.35, 0.35, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.listLampeggiantiBus = [];
		this.listLampeggiantiBus.push(new AccessoryPower(1, 'Lampeggianti Bus', 'BUS_CALC_FLA_KRX', 0.5, 3.5, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listLampeggiantiBus.push(new AccessoryPower(2, 'Lampeggianti Bus', 'BUS_CALC_FLA_GW_KRX', 1.5, 5, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));


		this.listSchede = [];
		this.listSchede.push(new AccessoryPower(1, 'Schede', 'BUS_AF43S_AF868', 0, 0, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSchede.push(new AccessoryPower(2, 'Schede', 'BUS_RIO', 0.2, 0.2, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSchede.push(new AccessoryPower(3, 'Schede', 'BUS_R700', 0.4, 0.4, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSchede.push(new AccessoryPower(4, 'Schede', 'BUS_R800', 0.3, 0.3, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		/*this.listSchede.push(new AccessoryPower(5, 'Schede', 'BUS_RCXN', 0.3, 0.3, 0,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));*/

		this.listSelR = [];
		this.listSelR.push(new AccessoryPower(1, 'Selettori', 'BUS_KEYPAD', 0.3, 0.3, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSelR.push(new AccessoryPower(2, 'Selettori', 'BUS_TRASPONDER', 0.4, 0.4, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));


		this.listFotocell = [];
		this.listFotocell.push(new AccessoryPower(1, 'Fotocellule', 'BUS_DIR_DLX_DELTA_DXR', 0, 0.1, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listFotocell.push(new AccessoryPower(2, 'Fotocellule', 'BUS_SMA', 0, 0, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.listLampeggiantiOld = [];
		this.listLampeggiantiOld.push(new AccessoryPower(1, 'Lampeggianti', 'BUS_KLED', 0, 3, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.busChange();

		this.translate.onLangChange.subscribe(() => {
			this.changeLegends();
		});

		/*this.totalLoadFotocellule.subscribe(() => {
			this.doughnutChartLabels = [];
			this.doughnutChartLabels.push(this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalLoadFotocellule +') ');
			this.doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS'));
			this.doughnutChartLabels.push(this.translate.instant('BUS_INTERFACES'));
			this.doughnutChartLabels.push(this.translate.instant('BUS_FLASHING'));
			this.doughnutChartLabels.push(this.translate.instant('BUS_AVAILABLE'));
		});*/

		const visibleCameInfoParam = this.route.snapshot.queryParamMap.get('cameInfo');
		if (visibleCameInfoParam != null && visibleCameInfoParam === 'false') {
			this.visibleCameInfo = false;
		}

		this.onResize();
	}

	resetForm(): void {
		this.maxPowerNorm = this.busSelect.limitGreenPower;
		this.maxPowerBus = this.busSelect.cxn;
		this.totalPower = this.busSelect.power;
		this.totalGreenPower = this.busSelect.powerGreen;

		this.totalLoadBoard = this.busSelect.power;
		this.totalGreenLoadBoard = this.busSelect.powerGreen;

		/** REMOVEEEE 
		if (this.enableGreenPower) {
			this.totalPower = this.busSelect.powerGreen;
		} else {
			this.totalPower = this.busSelect.power;
		}*/
		// MAX DEVICE
		this.maxGateway = this.busSelect.maxGateway;
		this.maxSchede = this.busSelect.maxSchede;
		this.maxFotocelluleBus = this.busSelect.maxFotocelluleBus;
		this.maxSelettoriBus = this.busSelect.maxSelettoriBus;
		this.maxInterfaccieBus = this.busSelect.maxInterfaccieBus;
		this.maxLampeggiantiBus = this.busSelect.maxLampeggiantiBus;
		this.maxFotocelluleOld = this.busSelect.maxFotocelluleOld;
		this.maxSelettoriOld = this.busSelect.maxSelettoriOld;
		this.maxLampeggiantiOld = this.busSelect.maxLampeggiantiOld;
		// MAX DEVICE

		for (const device of this.listSchede) {
			device.quantity = 0;
		}
		for (const device of this.listGateway) {
			device.quantity = 0;
		}
		for (const device of this.listFotocelluleBus) {
			device.quantity = 0;
		}
		for (const device of this.listSelettoriBus) {
			device.quantity = 0;
		}
		for (const device of this.listInterfaccieBus) {
			device.quantity = 0;
		}
		for (const device of this.listLampeggiantiBus) {
			device.quantity = 0;
		}
		for (const device of this.listSelR) {
			device.quantity = 0;
		}
		for (const device of this.listFotocell) {
			device.quantity = 0;
		}
		for (const device of this.listLampeggiantiOld) {
			device.quantity = 0;
		}
		this.totalSchede = 0;
		this.totalGateway = 0;
		this.totalFotocelluleBus = 0;
		this.totalSelettoriBus = 0;
		this.totalInterfaccieBus = 0;
		this.totalLampeggiantiBus = 0;
		this.totalSelettoriOld = 0;
		this.totalFotocelluleOld = 0;
		this.totalLampeggiantiOld = 0;

		this.totalLoadSchede = 0;
		this.totalLoadGateway = 0;
		this.totalLoadFotocelluleBus = 0;
		this.totalLoadSelettoriBus = 0;
		this.totalLoadInterfaccieBus = 0;
		this.totalLoadLampeggiantiBus = 0;
		this.totalLoadFotocelluleOld = 0;
		this.totalLoadSelettoriOld = 0;
		this.totalLoadLampeggiantiOld = 0;


		this.totalLoadBusPercentage = 0;
		this.totalLoadGatewayPercentage = 0;
		this.totalLoadFotocelluleBusPercentage = 0;
		this.totalLoadSelettoriBusPercentage = 0;
		this.totalLoadInterfaccieBusPercentage = 0;
		this.totalLoadLampeggiantiBusPercentage = 0;
		this.totalLoadFotocelluleOldPercentage = 0;
		this.totalLoadSelettoriOldPercentage = 0;
		this.totalLoadLampeggiantiOldPercentage = 0;


		this.totalGreenLoadSchede = 0;
		this.totalGreenLoadGateway = 0;
		this.totalGreenLoadFotocelluleBus = 0;
		this.totalGreenLoadSelettoriBus = 0;
		this.totalGreenLoadInterfaccieBus = 0;
		this.totalGreenLoadLampeggiantiBus = 0;
		this.totalGreenLoadFotocelluleOld = 0;
		this.totalGreenLoadSelettoriOld = 0;
		this.totalGreenLoadLampeggiantiOld = 0;


		this.totalGreenLoadBusPercentage = 0;
		this.totalGreenLoadGatewayPercentage = 0;
		this.totalGreenLoadFotocelluleBusPercentage = 0;
		this.totalGreenLoadSelettoriBusPercentage = 0;
		this.totalGreenLoadInterfaccieBusPercentage = 0;
		this.totalGreenLoadLampeggiantiBusPercentage = 0;
		this.totalGreenLoadFotocelluleOldPercentage = 0;
		this.totalGreenLoadSelettoriOldPercentage = 0;
		this.totalGreenLoadLampeggiantiOldPercentage = 0;

		this.calculateDisabledAddDevice();
	}

	resetFormGateway(): void {
		for (const device of this.listFotocelluleBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listSelettoriBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listInterfaccieBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listLampeggiantiBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listFotocell) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}

		for (const device of this.listSelR) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listLampeggiantiOld) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}


	}

	changeLegends(): void {
		/*const available = this.busSelect.cxn-this.totalLoadBus;
		const availablePercentage = 100 - this.totalLoadBusPercentage;*/
	}

	busChange(): void {
		this.resetForm();
		this.calculateDisabledAddDevice();
	}

	tooltips(tooltipItem: any): string {
		//const available = this.busSelect.cxn-this.totalLoadBus;
		const availablePercentage = 100 - this.totalLoadBusPercentage;
		switch (tooltipItem.index) {
			case 2: {
				return this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalFotocelluleBus + '): ' + this.totalLoadFotocelluleBusPercentage + '%';
			}
			case 3: {
				return this.translate.instant('BUS_SELECTORS') + ' (' + this.totalSelettoriBus + '): ' + this.totalLoadSelettoriBusPercentage + '%';
			}
			case 4: {
				return this.translate.instant('BUS_INTERFACES') + ' (' + this.totalInterfaccieBus + '): ' + this.totalLoadInterfaccieBusPercentage + '%';
			}
			case 5: {
				return this.translate.instant('BUS_FLASHING') + ' (' + this.totalLampeggiantiBus + '): ' + this.totalLoadLampeggiantiBusPercentage + '%';
			}
			case 6: {
				return this.translate.instant('BUS_AVAILABLE') + ': ' + availablePercentage + '%';
			}
		}
		return '-';
	}

	checkSelectable(device: AccessoryPower) {
		if (device.listBusActive.includes(this.busSelect.id)) {
			return false;
		}
		return true;
	}

	enabledAddWithBoard(device: AccessoryPower) {
		if (device.family === 'Selettori' && device.id === 1) { // KEYPAD
			const find = this.listSchede.find(sc => sc.id === 4); //BUS_R800
			return find.quantity <= 0;
		}
		if (device.family === 'Selettori' && device.id === 2) { // TRASPONDER
			const find = this.listSchede.find(sc => sc.id === 3); // BUS_R700
			return find.quantity <= 0;
		}
		return true;
	}

	subtractOne(device: AccessoryPower) {
		if (device.family === 'Schede' && device.id === 3) { //BUS_R700
			const find = this.listSelR.find(sc => sc.id === 2); // BUS_TRASPONDER
			const qt = find.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(find);
			}
		}
		if (device.family === 'Schede' && device.id === 4) { //BUS_R800
			const find = this.listSelR.find(sc => sc.id === 1); // BUS_KEYPAD
			const qt = find.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(find);
			}
		}
		if (device.quantity > 0) {
			device.quantity--;
			//this.totalPower = Number((this.totalPower - device.power).toFixed(2));
			switch (device.family) {
				case 'Gateway': {
					this.totalLoadGateway = Number((this.totalLoadGateway - device.power).toFixed(2));
					this.totalGreenLoadGateway = Number((this.totalGreenLoadGateway - device.powerGreen).toFixed(2));
					this.totalGateway--;
					break;
				} case 'Schede': {
					this.totalLoadSchede = Number((this.totalLoadSchede - device.power).toFixed(2));
					this.totalGreenLoadSchede = Number((this.totalGreenLoadSchede - device.powerGreen).toFixed(2));
					this.totalSchede--;
					break;
				}
				case 'Fotocellule Bus': {
					this.totalLoadFotocelluleBus = Number((this.totalLoadFotocelluleBus - device.power).toFixed(2));
					this.totalGreenLoadFotocelluleBus = Number((this.totalGreenLoadFotocelluleBus - device.powerGreen).toFixed(2));
					this.totalFotocelluleBus--;
					break;
				}
				case 'Selettori Bus': {
					this.totalLoadSelettoriBus = Number((this.totalLoadSelettoriBus - device.power).toFixed(2));
					this.totalGreenLoadSelettoriBus = Number((this.totalGreenLoadSelettoriBus - device.powerGreen).toFixed(2));
					this.totalSelettoriBus--;
					break;
				}
				case 'Interfacce Bus': {
					this.totalLoadInterfaccieBus = Number((this.totalLoadInterfaccieBus - device.power).toFixed(2));
					this.totalGreenLoadInterfaccieBus = Number((this.totalGreenLoadInterfaccieBus - device.powerGreen).toFixed(2));
					this.totalInterfaccieBus--;
					break;
				}
				case 'Lampeggianti Bus': {
					this.totalLoadLampeggiantiBus = Number((this.totalLoadLampeggiantiBus - device.power).toFixed(2));
					this.totalGreenLoadLampeggiantiBus = Number((this.totalGreenLoadLampeggiantiBus - device.powerGreen).toFixed(2));
					this.totalLampeggiantiBus--;
					break;
				}
				case 'Fotocellule': {
					this.totalLoadFotocelluleOld = Number((this.totalLoadFotocelluleOld - device.power).toFixed(2));
					this.totalGreenLoadFotocelluleOld = Number((this.totalGreenLoadFotocelluleOld - device.powerGreen).toFixed(2));
					this.totalFotocelluleOld--;
					break;
				}
				case 'Selettori': {
					this.totalLoadSelettoriOld = Number((this.totalLoadSelettoriOld - device.power).toFixed(2));
					this.totalGreenLoadSelettoriOld = Number((this.totalGreenLoadSelettoriOld - device.powerGreen).toFixed(2));
					this.totalSelettoriOld--;
					break;
				}
				case 'Lampeggianti': {
					this.totalLoadLampeggiantiOld = Number((this.totalLoadLampeggiantiOld - device.power).toFixed(2));
					this.totalGreenLoadLampeggiantiOld = Number((this.totalGreenLoadLampeggiantiOld - device.powerGreen).toFixed(2));
					this.totalLampeggiantiOld--;
					break;
				}
			}
			if (this.enableGreenPower && device.family === 'Gateway') {
				this.resetFormGateway();
			}
		}
		this.calculateDisabledAddDevice();
	}

	addOne(device: AccessoryPower) {
		if (device.family === 'Fotocellule' && device.id === 2) {
			this.showDialog2();
			return;
		}
		if (device.family === 'Gateway' && device.id === 4) {
			this.showDialog2();
			return;
		}
		if (device.family === 'Gateway' && device.id === 5) {
			this.showDialog2();
			return;
		}
		if (device.family === 'Schede' && device.id === 3) { //BUS_R700
			this.maxSelettoriOld = 2;
		}
		if (device.family === 'Schede' && device.id === 4) { //BUS_R800
			this.maxSelettoriOld = 4;
		}
		device.quantity++;
		//this.totalPower = Number((this.totalPower + device.power).toFixed(2));
		switch (device.family) {
			case 'Gateway': {
				this.totalLoadGateway = Number((this.totalLoadGateway + device.power).toFixed(2));
				this.totalGreenLoadGateway = Number((this.totalGreenLoadGateway + device.powerGreen).toFixed(2));
				this.totalGateway++;
				break;
			}
			case 'Schede': {
				this.totalLoadSchede = Number((this.totalLoadSchede + device.power).toFixed(2));
				this.totalGreenLoadSchede = Number((this.totalGreenLoadSchede + device.powerGreen).toFixed(2));
				this.totalSchede++;
				break;
			}
			case 'Fotocellule Bus': {
				this.totalLoadFotocelluleBus = Number((this.totalLoadFotocelluleBus + device.power).toFixed(2));
				this.totalGreenLoadFotocelluleBus = Number((this.totalGreenLoadFotocelluleBus + device.powerGreen).toFixed(2));
				this.totalFotocelluleBus++;
				break;
			}
			case 'Selettori Bus': {
				this.totalLoadSelettoriBus = Number((this.totalLoadSelettoriBus + device.power).toFixed(2));
				this.totalGreenLoadSelettoriBus = Number((this.totalGreenLoadSelettoriBus + device.powerGreen).toFixed(2));
				this.totalSelettoriBus++;
				break;
			}
			case 'Interfacce Bus': {
				this.totalLoadInterfaccieBus = Number((this.totalLoadInterfaccieBus + device.power).toFixed(2));
				this.totalGreenLoadInterfaccieBus = Number((this.totalGreenLoadInterfaccieBus + device.powerGreen).toFixed(2));
				this.totalInterfaccieBus++;
				break;
			}
			case 'Lampeggianti Bus': {
				this.totalLoadLampeggiantiBus = Number((this.totalLoadLampeggiantiBus + device.power).toFixed(2));
				this.totalGreenLoadLampeggiantiBus = Number((this.totalGreenLoadLampeggiantiBus + device.powerGreen).toFixed(2));
				this.totalLampeggiantiBus++;
				break;
			}
			case 'Fotocellule': {
				this.totalLoadFotocelluleOld = Number((this.totalLoadFotocelluleOld + device.power).toFixed(2));
				this.totalGreenLoadFotocelluleOld = Number((this.totalGreenLoadFotocelluleOld + device.powerGreen).toFixed(2));
				this.totalFotocelluleOld++;
				break;
			}
			case 'Selettori': {
				this.totalLoadSelettoriOld = Number((this.totalLoadSelettoriOld + device.power).toFixed(2));
				this.totalGreenLoadSelettoriOld = Number((this.totalGreenLoadSelettoriOld + device.powerGreen).toFixed(2));
				this.totalSelettoriOld++;
				break;
			}
			case 'Lampeggianti': {
				this.totalLoadLampeggiantiOld = Number((this.totalLoadLampeggiantiOld + device.power).toFixed(2));
				this.totalGreenLoadLampeggiantiOld = Number((this.totalGreenLoadLampeggiantiOld + device.powerGreen).toFixed(2));
				this.totalLampeggiantiOld++;
				break;
			}
		}
		this.calculateDisabledAddDevice();
	}

	calculateDisabledAddDevice(): void {
		this.maxPowerNorm = this.busSelect.limitGreenPower;
		this.maxPowerBus = this.busSelect.cxn;
		this.totalBoard = this.busSelect.power;
		/*for (const bus of this.listBus) {
			bus.disableAdd = this.totalLoadBus > bus.power;
		}*/

		if (this.enableGreenPower) {
			this.totalBoard = this.busSelect.powerGreen;
		}
		this.maxPowerNorm = this.busSelect.limitGreenPower;
		for (const device of this.listGateway) {
			if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPowerNorm < device.limitGreenPower) {
				this.maxPowerNorm = device.limitGreenPower;
			}
		}
		for (const device of this.listSchede) {
			if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPowerNorm < device.limitGreenPower) {
				this.maxPowerNorm = device.limitGreenPower;
			}
		}
		for (const device of this.listSelettoriBus) {
			if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPowerNorm < device.limitGreenPower) {
				this.maxPowerNorm = device.limitGreenPower;
			}
		}
		for (const device of this.listFotocelluleBus) {
			if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPowerNorm < device.limitGreenPower) {
				this.maxPowerNorm = device.limitGreenPower;
			}
		}
		for (const device of this.listInterfaccieBus) {
			if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPowerNorm < device.limitGreenPower) {
				this.maxPowerNorm = device.limitGreenPower;
			}
		}
		for (const device of this.listSelR) {
			if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPowerNorm < device.limitGreenPower) {
				this.maxPowerNorm = device.limitGreenPower;
			}
		}
		for (const device of this.listFotocell) {
			if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPowerNorm < device.limitGreenPower) {
				this.maxPowerNorm = device.limitGreenPower;
			}
		}
		for (const device of this.listLampeggiantiOld) {
			if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPowerNorm < device.limitGreenPower) {
				this.maxPowerNorm = device.limitGreenPower;
			}
		}
		// POWER
		let totPow = Number((this.totalBoard + this.totalLoadSchede + this.totalLoadGateway + this.totalLoadSelettoriBus + this.totalLoadFotocelluleBus + this.totalLoadLampeggiantiBus +
			this.totalLoadInterfaccieBus + this.totalLoadSelettoriOld + this.totalLoadFotocelluleOld + this.totalLoadLampeggiantiOld).toFixed(2));

		if (this.enableGreenPower) {
			// GREEN POWER
			totPow = Number((this.totalBoard + this.totalGreenLoadSchede + this.totalGreenLoadGateway + this.totalGreenLoadSelettoriBus +
				this.totalGreenLoadFotocelluleBus + this.totalGreenLoadLampeggiantiBus +
				this.totalGreenLoadInterfaccieBus + this.totalGreenLoadSelettoriOld + this.totalGreenLoadFotocelluleOld +
				this.totalGreenLoadLampeggiantiOld).toFixed(2));
		}
		if (totPow > this.busSelect.maxPowerGreen) {
			this.totalBoard = this.busSelect.power;
		}

		// POWER
		this.totalPower = Number((this.totalBoard + this.totalLoadSchede + this.totalLoadGateway + this.totalLoadSelettoriBus + this.totalLoadFotocelluleBus + this.totalLoadLampeggiantiBus +
			this.totalLoadInterfaccieBus + this.totalLoadSelettoriOld + this.totalLoadFotocelluleOld + this.totalLoadLampeggiantiOld).toFixed(2));
		if (this.enableGreenPower) {
			// GREEN POWER
			this.totalPower = Number((this.totalBoard + this.totalGreenLoadSchede + this.totalGreenLoadGateway + this.totalGreenLoadSelettoriBus +
				this.totalGreenLoadFotocelluleBus + this.totalGreenLoadLampeggiantiBus +
				this.totalGreenLoadInterfaccieBus + this.totalGreenLoadSelettoriOld + this.totalGreenLoadFotocelluleOld + this.totalGreenLoadLampeggiantiOld).toFixed(2));
		}

		this.totalPowerBus = Number((this.totalLoadSelettoriBus + this.totalLoadFotocelluleBus + this.totalLoadLampeggiantiBus +
			this.totalLoadInterfaccieBus).toFixed(2));
		const delta = this.busSelect.maxPowerGreen - this.totalPower;
		const deltaBus = this.maxPowerBus - this.totalPowerBus;

		// GREEN POWER

		for (const gateway of this.listGateway) {
			gateway.disableAdd = this.totalGateway === this.maxGateway;
			gateway.disableRemove = gateway.quantity === 0;
		}

		for (const scheda of this.listSchede) {
			if (scheda.id === 1) {// Custom for BUS_AF43S_AF868
				scheda.disableAdd = scheda.powerGreen > delta || scheda.quantity > 0;
			} else if (scheda.id === 2) {// Custom for BUS_RIO
				scheda.disableAdd = scheda.powerGreen > delta || scheda.quantity > 0;
			} else if (scheda.id === 3) {// Custom for BUS_R700
				const find = this.listSchede.find(sc => sc.id === 4);
				scheda.disableAdd = scheda.quantity > 0 || find.quantity > 0;
			} else if (scheda.id === 4) {// Custom for BUS_R800
				const find = this.listSchede.find(sc => sc.id === 3);
				scheda.disableAdd = scheda.quantity > 0 || find.quantity > 0;
			} /*else if (scheda.id === 5) {// Custom for BUS_RCXN
				scheda.disableAdd = scheda.quantity > 0 || this.busSelect.id !== 5; //ZLX230
			}*/
			scheda.disableRemove = scheda.quantity === 0;
		}
		for (const fotocellula of this.listFotocelluleBus) {
			fotocellula.disableAdd = this.totalFotocelluleBus === this.maxFotocelluleBus || fotocellula.power > deltaBus;
			fotocellula.disableRemove = fotocellula.quantity === 0;
		}
		for (const selettore of this.listSelettoriBus) {
			if (selettore.limitGreenPower > 0) {
				let limitGreenPower = this.maxPowerNorm;
				if (selettore.limitGreenPower > limitGreenPower) {
					limitGreenPower = selettore.limitGreenPower;
				}
			}
			selettore.disableAdd = this.totalSelettoriBus === this.maxSelettoriBus || selettore.power > deltaBus;
			selettore.disableRemove = selettore.quantity === 0;
		}
		for (const interfaccia of this.listInterfaccieBus) {
			if (interfaccia.limitGreenPower > 0) {
				let limitGreenPower = this.maxPowerNorm;
				if (interfaccia.limitGreenPower > limitGreenPower) {
					limitGreenPower = interfaccia.limitGreenPower;
				}
			}
			interfaccia.disableAdd = this.totalInterfaccieBus === this.maxInterfaccieBus || interfaccia.power > deltaBus
			interfaccia.disableRemove = interfaccia.quantity === 0;
		}
		for (const lampeggiante of this.listLampeggiantiBus) {
			if (lampeggiante.limitGreenPower > 0) {
				let limitGreenPower = this.maxPowerNorm;
				if (lampeggiante.limitGreenPower > limitGreenPower) {
					limitGreenPower = lampeggiante.limitGreenPower;
				}
			}
			lampeggiante.disableAdd = this.totalLampeggiantiBus === this.maxLampeggiantiBus || lampeggiante.power > deltaBus;
			lampeggiante.disableRemove = lampeggiante.quantity === 0;
		}
		for (const fotocellula of this.listFotocell) {
			if (fotocellula.limitGreenPower > 0) {
				let limitGreenPower = this.maxPowerNorm;
				if (fotocellula.limitGreenPower > limitGreenPower) {
					limitGreenPower = fotocellula.limitGreenPower;
				}
			}
			fotocellula.disableAdd = this.totalFotocelluleOld === this.maxFotocelluleOld;
			fotocellula.disableRemove = fotocellula.quantity === 0;
		}
		for (const selettore of this.listSelR) {
			if (selettore.limitGreenPower > 0) {
				let limitGreenPower = this.maxPowerNorm;
				if (selettore.limitGreenPower > limitGreenPower) {
					limitGreenPower = selettore.limitGreenPower;
				}
			}
			selettore.disableAdd = this.totalSelettoriOld === this.maxSelettoriOld;
			selettore.disableRemove = selettore.quantity === 0;
		}
		for (const lampeggiante of this.listLampeggiantiOld) {
			if (lampeggiante.limitGreenPower > 0) {
				let limitGreenPower = this.maxPowerNorm;
				if (lampeggiante.limitGreenPower > limitGreenPower) {
					limitGreenPower = lampeggiante.limitGreenPower;
				}
			}
			lampeggiante.disableAdd = this.totalLampeggiantiOld === this.maxLampeggiantiOld;
			lampeggiante.disableRemove = lampeggiante.quantity === 0;
		}
		//---------POWER----------------
		this.totalLoadBusPercentage = Math.floor(this.totalPower / this.busSelect.maxPower * 100);
		this.totalLoadBoardPercentage = Math.floor(this.totalLoadBoard / this.busSelect.maxPower * 100);
		this.totalLoadGatewayPercentage = Math.floor(this.totalLoadGateway / this.busSelect.maxPower * 100);
		this.totalLoadSchedePercentage = Math.floor(this.totalLoadSchede / this.busSelect.maxPower * 100);
		this.totalLoadFotocelluleBusPercentage = Math.floor(this.totalLoadFotocelluleBus / this.busSelect.maxPower * 100);
		this.totalLoadSelettoriBusPercentage = Math.floor(this.totalLoadSelettoriBus / this.busSelect.maxPower * 100);
		this.totalLoadInterfaccieBusPercentage = Math.floor(this.totalLoadInterfaccieBus / this.busSelect.maxPower * 100);
		this.totalLoadLampeggiantiBusPercentage = Math.floor(this.totalLoadLampeggiantiBus / this.busSelect.maxPower * 100);
		this.totalLoadFotocelluleOldPercentage = Math.floor(this.totalLoadFotocelluleOld / this.busSelect.maxPower * 100);
		this.totalLoadSelettoriOldPercentage = Math.floor(this.totalLoadSelettoriOld / this.busSelect.maxPower * 100);
		this.totalLoadLampeggiantiOldPercentage = Math.floor(this.totalLoadLampeggiantiOld / this.busSelect.maxPower * 100);
		//-----------POWER---------------
		//----------GREEN POWER----------------
		this.totalGreenLoadBusPercentage = Math.floor(this.totalGreenPower / this.busSelect.maxPower * 100);
		this.totalGreenLoadBoardPercentage = Math.floor(this.totalGreenLoadBoard / this.busSelect.maxPower * 100);
		this.totalGreenLoadGatewayPercentage = Math.floor(this.totalGreenLoadGateway / this.busSelect.maxPower * 100);
		this.totalGreenLoadSchedePercentage = Math.floor(this.totalGreenLoadSchede / this.busSelect.maxPower * 100);
		this.totalGreenLoadFotocelluleBusPercentage = Math.floor(this.totalGreenLoadFotocelluleBus / this.busSelect.maxPower * 100);
		this.totalGreenLoadSelettoriBusPercentage = Math.floor(this.totalGreenLoadSelettoriBus / this.busSelect.maxPower * 100);
		this.totalGreenLoadInterfaccieBusPercentage = Math.floor(this.totalGreenLoadInterfaccieBus / this.busSelect.maxPower * 100);
		this.totalGreenLoadLampeggiantiBusPercentage = Math.floor(this.totalGreenLoadLampeggiantiBus / this.busSelect.maxPower * 100);
		this.totalGreenLoadFotocelluleOldPercentage = Math.floor(this.totalGreenLoadFotocelluleOld / this.busSelect.maxPower * 100);
		this.totalGreenLoadSelettoriOldPercentage = Math.floor(this.totalGreenLoadSelettoriOld / this.busSelect.maxPower * 100);
		this.totalGreenLoadLampeggiantiOldPercentage = Math.floor(this.totalGreenLoadLampeggiantiOld / this.busSelect.maxPower * 100);
		//-----------GREEN POWER---------------
		if (this.enableGreenPower) {
			this.totalLoadBoardPercentageLimitGreenPower = Math.floor(this.totalGreenLoadBoard / this.busSelect.maxPowerGreen * 100);
			this.totalLoadGatewayPercentageLimitGreenPower = Math.floor(this.totalGreenLoadGateway / this.busSelect.maxPowerGreen * 100);
			this.totalLoadSchedePercentageLimitGreenPower = Math.floor(this.totalGreenLoadSchede / this.busSelect.maxPowerGreen * 100);
			this.totalLoadFotocelluleBusPercentageLimitGreenPower = Math.floor(this.totalGreenLoadFotocelluleBus / this.busSelect.maxPowerGreen * 100);
			this.totalLoadSelettoriBusPercentageLimitGreenPower = Math.floor(this.totalGreenLoadSelettoriBus / this.busSelect.maxPowerGreen * 100);
			this.totalLoadInterfaccieBusPercentageLimitGreenPower = Math.floor(this.totalGreenLoadInterfaccieBus / this.busSelect.maxPowerGreen * 100);
			this.totalLoadLampeggiantiBusPercentageLimitGreenPower = Math.floor(this.totalGreenLoadLampeggiantiBus / this.busSelect.maxPowerGreen * 100);
			this.totalLoadFotocelluleOldPercentageLimitGreenPower = Math.floor(this.totalGreenLoadFotocelluleOld / this.busSelect.maxPowerGreen * 100);
			this.totalLoadSelettoriOldPercentageLimitGreenPower = Math.floor(this.totalGreenLoadSelettoriOld / this.busSelect.maxPowerGreen * 100);
			this.totalLoadLampeggiantiOldPercentageLimitGreenPower = Math.floor(this.totalGreenLoadLampeggiantiOld / this.busSelect.maxPowerGreen * 100);
			//--------------------------
			this.totalLoadBusPercentageNorm = Math.floor(this.totalGreenPower / this.maxPowerNorm * 100);
			this.totalLoadBoardPercentageNorm = Math.floor(this.totalGreenLoadBoard / this.maxPowerNorm * 100);
			this.totalLoadGatewayPercentageNorm = Math.floor(this.totalGreenLoadGateway / this.maxPowerNorm * 100);
			this.totalLoadSchedePercentageNorm = Math.floor(this.totalGreenLoadSchede / this.maxPowerNorm * 100);
			this.totalLoadFotocelluleBusPercentageNorm = Math.floor(this.totalGreenLoadFotocelluleBus / this.maxPowerNorm * 100);
			this.totalLoadSelettoriBusPercentageNorm = Math.floor(this.totalGreenLoadSelettoriBus / this.maxPowerNorm * 100);
			this.totalLoadInterfaccieBusPercentageNorm = Math.floor(this.totalGreenLoadInterfaccieBus / this.maxPowerNorm * 100);
			this.totalLoadLampeggiantiBusPercentageNorm = Math.floor(this.totalGreenLoadLampeggiantiBus / this.maxPowerNorm * 100);
			this.totalLoadFotocelluleOldPercentageNorm = Math.floor(this.totalGreenLoadFotocelluleOld / this.maxPowerNorm * 100);
			this.totalLoadSelettoriOldPercentageNorm = Math.floor(this.totalGreenLoadSelettoriOld / this.maxPowerNorm * 100);
			this.totalLoadLampeggiantiOldPercentageNorm = Math.floor(this.totalGreenLoadLampeggiantiOld / this.maxPowerNorm * 100);
			//--------------------------
		} else {
			this.totalLoadBoardPercentageLimitGreenPower = Math.floor(this.totalLoadBoard / this.busSelect.maxPowerGreen * 100);
			this.totalLoadGatewayPercentageLimitGreenPower = Math.floor(this.totalLoadGateway / this.busSelect.maxPowerGreen * 100);
			this.totalLoadSchedePercentageLimitGreenPower = Math.floor(this.totalLoadSchede / this.busSelect.maxPowerGreen * 100);
			this.totalLoadFotocelluleBusPercentageLimitGreenPower = Math.floor(this.totalLoadFotocelluleBus / this.busSelect.maxPowerGreen * 100);
			this.totalLoadSelettoriBusPercentageLimitGreenPower = Math.floor(this.totalLoadSelettoriBus / this.busSelect.maxPowerGreen * 100);
			this.totalLoadInterfaccieBusPercentageLimitGreenPower = Math.floor(this.totalLoadInterfaccieBus / this.busSelect.maxPowerGreen * 100);
			this.totalLoadLampeggiantiBusPercentageLimitGreenPower = Math.floor(this.totalLoadLampeggiantiBus / this.busSelect.maxPowerGreen * 100);
			this.totalLoadFotocelluleOldPercentageLimitGreenPower = Math.floor(this.totalLoadFotocelluleOld / this.busSelect.maxPowerGreen * 100);
			this.totalLoadSelettoriOldPercentageLimitGreenPower = Math.floor(this.totalLoadSelettoriOld / this.busSelect.maxPowerGreen * 100);
			this.totalLoadLampeggiantiOldPercentageLimitGreenPower = Math.floor(this.totalLoadLampeggiantiOld / this.busSelect.maxPowerGreen * 100);
			//--------------------------
			this.totalLoadBusPercentageNorm = Math.floor(this.totalPower / this.maxPowerNorm * 100);
			this.totalLoadBoardPercentageNorm = Math.floor(this.totalLoadBoard / this.maxPowerNorm * 100);
			this.totalLoadGatewayPercentageNorm = Math.floor(this.totalLoadGateway / this.maxPowerNorm * 100);
			this.totalLoadSchedePercentageNorm = Math.floor(this.totalLoadSchede / this.maxPowerNorm * 100);
			this.totalLoadFotocelluleBusPercentageNorm = Math.floor(this.totalLoadFotocelluleBus / this.maxPowerNorm * 100);
			this.totalLoadSelettoriBusPercentageNorm = Math.floor(this.totalLoadSelettoriBus / this.maxPowerNorm * 100);
			this.totalLoadInterfaccieBusPercentageNorm = Math.floor(this.totalLoadInterfaccieBus / this.maxPowerNorm * 100);
			this.totalLoadLampeggiantiBusPercentageNorm = Math.floor(this.totalLoadLampeggiantiBus / this.maxPowerNorm * 100);
			this.totalLoadFotocelluleOldPercentageNorm = Math.floor(this.totalLoadFotocelluleOld / this.maxPowerNorm * 100);
			this.totalLoadSelettoriOldPercentageNorm = Math.floor(this.totalLoadSelettoriOld / this.maxPowerNorm * 100);
			this.totalLoadLampeggiantiOldPercentageNorm = Math.floor(this.totalLoadLampeggiantiOld / this.maxPowerNorm * 100);
			//--------------------------
		}
		this.totalLoadFotocelluleBusPercentageBus = Math.floor(this.totalLoadFotocelluleBus / this.busSelect.cxn * 100);
		this.totalLoadSelettoriBusPercentageBus = Math.floor(this.totalLoadSelettoriBus / this.busSelect.cxn * 100);
		this.totalLoadInterfaccieBusPercentageBus = Math.floor(this.totalLoadInterfaccieBus / this.busSelect.cxn * 100);
		this.totalLoadLampeggiantiBusPercentageBus = Math.floor(this.totalLoadLampeggiantiBus / this.busSelect.cxn * 100);
		this.elaborateGraphic();
	}

	elaborateGraphic(): void {

		this.statusPower = 0;
		this.statusLimitGreenPower = 0;
		this.statusPowerNorm = 0;
		this.statusPowerBus = 0;

		/*this.valuePower = [
			{ color: '#34d399', value: 16 },
			{ color: '#fbbf24', value: 8 },
			{ color: '#60a5fa', value: 24 },
			{ color: '#c084fc', value: 10 }
		];*/
		this.valuePower = [];
		this.valueGreenPower = [];
		this.valueCalcPower = [];
		this.valueCalcPowerBus = [];
		//const doughnutChartLabels = [this.translate.instant('BUS_PANEL') + ' (' + this.totalBoard + '): ' + this.totalLoadBoardPercentage + '%'];
		const backgroundColorChart = [];
		//const arrayDataSet = [this.totalLoadBoardPercentage];
		if (this.enableGreenPower) {
			this.valuePower.push({ color: 'yellow', value: this.totalGreenLoadBoardPercentage });
		} else {
			this.valuePower.push({ color: 'yellow', value: this.totalLoadBoardPercentage });
		}
		this.valueGreenPower.push({ color: 'yellow', value: this.totalLoadBoardPercentageLimitGreenPower });
		//this.valueCalcPower.push({ color: 'black', value: this.totalLoadBoardPercentageNorm });
		if (this.busSelect.maxGateway > 0) {
			//doughnutChartLabels.push(this.translate.instant('GATEWAY') + ' (' + this.totalGateway + '): ' + this.totalLoadGatewayPercentage + '%');
			//backgroundColor.push('ligthblue');
			//arrayDataSet.push(this.totalLoadGatewayPercentage);
			if (this.enableGreenPower) {
				this.valuePower.push({ color: 'ligthblue', value: this.totalGreenLoadGatewayPercentage });
			} else {
				this.valuePower.push({ color: 'ligthblue', value: this.totalLoadGatewayPercentage });
			}
			this.valueGreenPower.push({ color: 'ligthblue', value: this.totalLoadGatewayPercentageLimitGreenPower });
			//	this.valueCalcPower.push({ color: 'ligthblue', value: this.totalLoadGatewayPercentageNorm });
		}
		if (this.busSelect.maxSchede > 0) {
			//doughnutChartLabels.push(this.translate.instant('BUS_BOARD') + ' (' + this.totalSchede + '): ' + this.totalLoadSchedePercentage + '%');
			//backgroundColor.push('purple');
			//arrayDataSet.push(this.totalLoadSchedePercentage);
			if (this.enableGreenPower) {
				this.valuePower.push({ color: 'purple', value: this.totalGreenLoadSchedePercentage });
			} else {
				this.valuePower.push({ color: 'purple', value: this.totalLoadSchedePercentage });
			}
			this.valueGreenPower.push({ color: 'purple', value: this.totalLoadSchedePercentageLimitGreenPower });
			//	this.valueCalcPower.push({ color: 'purple', value: this.totalLoadSchedePercentageNorm });
		}
		if (this.busSelect.maxSelettoriBus > 0) {
			//doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS_BUS') + ' (' + this.totalSelettoriBus + '): ' + this.totalLoadSelettoriBusPercentage + '%');
			backgroundColorChart.push('orange');
			//arrayDataSet.push(this.totalLoadFotocelluleBusPercentage);
			if (this.enableGreenPower) {
				this.valuePower.push({ color: 'orange', value: this.totalGreenLoadSelettoriBusPercentage });
			} else {
				this.valuePower.push({ color: 'orange', value: this.totalLoadSelettoriBusPercentage });
			}
			this.valueGreenPower.push({ color: 'orange', value: this.totalLoadSelettoriBusPercentageLimitGreenPower });
			//	this.valueCalcPower.push({ color: 'orange', value: this.totalLoadSelettoriBusPercentageNorm });
			this.valueCalcPowerBus.push({ color: 'orange', value: this.totalLoadSelettoriBusPercentageBus });
		}
		if (this.busSelect.maxFotocelluleBus > 0) {
			//doughnutChartLabels.push(this.translate.instant('BUS_PHOTOCELLS_BUS') + ' (' + this.totalFotocelluleBus + '): ' + this.totalLoadFotocelluleBusPercentage + '%');
			backgroundColorChart.push('green');
			//arrayDataSet.push(this.totalLoadSelettoriBusPercentage);
			if (this.enableGreenPower) {
				this.valuePower.push({ color: 'green', value: this.totalGreenLoadFotocelluleBusPercentage });
			} else {
				this.valuePower.push({ color: 'green', value: this.totalLoadFotocelluleBusPercentage });
			}
			this.valueGreenPower.push({ color: 'green', value: this.totalLoadFotocelluleBusPercentageLimitGreenPower });
			//this.valueCalcPower.push({ color: 'green', value: this.totalLoadFotocelluleBusPercentageNorm });
			this.valueCalcPowerBus.push({ color: 'green', value: this.totalLoadFotocelluleBusPercentageBus });
		}
		if (this.busSelect.maxInterfaccieBus > 0) {
			//doughnutChartLabels.push(this.translate.instant('BUS_INTERFACES_BUS') + ' (' + this.totalInterfaccieBus + '): ' + this.totalLoadInterfaccieBusPercentage + '%');
			backgroundColorChart.push('blue');
			//rrayDataSet.push(this.totalLoadInterfaccieBusPercentage);
			if (this.enableGreenPower) {
				this.valuePower.push({ color: 'blue', value: this.totalGreenLoadInterfaccieBusPercentage });
			} else {
				this.valuePower.push({ color: 'blue', value: this.totalLoadInterfaccieBusPercentage });
			}
			this.valueGreenPower.push({ color: 'blue', value: this.totalLoadInterfaccieBusPercentageLimitGreenPower });
			//	this.valueCalcPower.push({ color: 'blue', value: this.totalLoadInterfaccieBusPercentageNorm });
			this.valueCalcPowerBus.push({ color: 'blue', value: this.totalLoadInterfaccieBusPercentageBus });
		}
		if (this.busSelect.maxLampeggiantiBus > 0) {
			//doughnutChartLabels.push(this.translate.instant('BUS_FLASHING_BUS') + ' (' + this.totalLampeggiantiBus + '): ' + this.totalLoadLampeggiantiBusPercentage + '%');
			backgroundColorChart.push('pink');
			//arrayDataSet.push(this.totalLoadLampeggiantiBusPercentage);
			if (this.enableGreenPower) {
				this.valuePower.push({ color: 'pink', value: this.totalGreenLoadLampeggiantiBusPercentage });
			} else {
				this.valuePower.push({ color: 'pink', value: this.totalLoadLampeggiantiBusPercentage });
			}
			this.valueGreenPower.push({ color: 'pink', value: this.totalLoadLampeggiantiBusPercentageLimitGreenPower });
			//	this.valueCalcPower.push({ color: 'pink', value: this.totalLoadLampeggiantiBusPercentageNorm });
			this.valueCalcPowerBus.push({ color: 'pink', value: this.totalLoadLampeggiantiBusPercentageBus });
		}
		if (this.busSelect.maxSelettoriOld > 0) {
			//doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS') + ' (' + this.totalSelettoriOld + '): ' + this.totalLoadSelettoriOldPercentage + '%');
			//backgroundColor.push('green');
			//arrayDataSet.push(this.totalLoadSelettoriOldPercentage);
			if (this.enableGreenPower) {
				this.valuePower.push({ color: 'green', value: this.totalGreenLoadSelettoriOldPercentage });
			} else {
				this.valuePower.push({ color: 'green', value: this.totalLoadSelettoriOldPercentage });
			}
			this.valueGreenPower.push({ color: 'green', value: this.totalLoadSelettoriOldPercentageLimitGreenPower });
			//	this.valueCalcPower.push({ color: 'green', value: this.totalLoadSelettoriOldPercentageNorm });
		}
		if (this.busSelect.maxFotocelluleOld > 0) {
			//doughnutChartLabels.push(this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalFotocelluleOld + '): ' + this.totalLoadFotocelluleOldPercentage + '%');
			//backgroundColor.push('orange');
			//arrayDataSet.push(this.totalLoadFotocelluleOldPercentage);
			if (this.enableGreenPower) {
				this.valuePower.push({ color: 'orange', value: this.totalGreenLoadFotocelluleOldPercentage });
			} else {
				this.valuePower.push({ color: 'orange', value: this.totalLoadFotocelluleOldPercentage });
			}
			this.valueGreenPower.push({ color: 'orange', value: this.totalLoadFotocelluleOldPercentageLimitGreenPower });
			//	this.valueCalcPower.push({ color: 'orange', value: this.totalLoadFotocelluleOldPercentageNorm });
		}
		if (this.busSelect.maxLampeggiantiOld > 0) {
			//doughnutChartLabels.push(this.translate.instant('BUS_FLASHING_BUS') + ' (' + this.totalLampeggiantiBus + '): ' + this.totalLoadLampeggiantiBusPercentage + '%');
			backgroundColorChart.push('pink');
			//arrayDataSet.push(this.totalLoadLampeggiantiOldPercentage);
			if (this.enableGreenPower) {
				this.valuePower.push({ color: 'pink', value: this.totalGreenLoadLampeggiantiOldPercentage });
			} else {
				this.valuePower.push({ color: 'pink', value: this.totalLoadLampeggiantiOldPercentage });
			}
			this.valueGreenPower.push({ color: 'pink', value: this.totalLoadLampeggiantiOldPercentageLimitGreenPower });
			//	this.valueCalcPower.push({ color: 'pink', value: this.totalLoadLampeggiantiOldPercentageNorm });
		}
		//doughnutChartLabels.push(this.translate.instant('BUS_AVAILABLE') + ': ' + 100 + '%');
		backgroundColorChart.push('#E5E6E7');
		const delta = 100 - this.totalLoadBusPercentage;
		//arrayDataSet.push(delta);
		//--------------------------
		const deltaLimitGreenPower = 100 - this.totalLoadBoardPercentageLimitGreenPower - this.totalLoadGatewayPercentageLimitGreenPower -
			this.totalLoadSchedePercentageLimitGreenPower - this.totalLoadFotocelluleBusPercentageLimitGreenPower -
			this.totalLoadSelettoriBusPercentageLimitGreenPower - this.totalLoadInterfaccieBusPercentageLimitGreenPower -
			this.totalLoadLampeggiantiBusPercentageLimitGreenPower - this.totalLoadFotocelluleOldPercentageLimitGreenPower -
			this.totalLoadSelettoriOldPercentageLimitGreenPower - this.totalLoadLampeggiantiOldPercentageLimitGreenPower;
		let totLimitGreenNorm = this.totalLoadBoard + this.totalLoadGateway +
			this.totalLoadSchede + this.totalLoadFotocelluleBus +
			this.totalLoadSelettoriBus + this.totalLoadInterfaccieBus +
			this.totalLoadLampeggiantiBus + this.totalLoadFotocelluleOld +
			this.totalLoadSelettoriOld + this.totalLoadLampeggiantiOld;
		if (this.enableGreenPower) {
			totLimitGreenNorm = this.totalGreenLoadBoard + this.totalGreenLoadGateway +
				this.totalGreenLoadSchede + this.totalGreenLoadFotocelluleBus +
				this.totalGreenLoadSelettoriBus + this.totalGreenLoadInterfaccieBus +
				this.totalGreenLoadLampeggiantiBus + this.totalGreenLoadFotocelluleOld +
				this.totalGreenLoadSelettoriOld + this.totalGreenLoadLampeggiantiOld;
		}
		const deltaLimitGreenNorm = 100 - this.totalLoadBoardPercentageNorm - this.totalLoadGatewayPercentageNorm -
			this.totalLoadSchedePercentageNorm - this.totalLoadFotocelluleBusPercentageNorm -
			this.totalLoadSelettoriBusPercentageNorm - this.totalLoadInterfaccieBusPercentageNorm -
			this.totalLoadLampeggiantiBusPercentageNorm - this.totalLoadFotocelluleOldPercentageNorm -
			this.totalLoadSelettoriOldPercentageNorm + this.totalLoadLampeggiantiOldPercentageNorm;
		const deltaBus = 100 - this.totalLoadFotocelluleBusPercentageBus -
			this.totalLoadSelettoriBusPercentageBus - this.totalLoadInterfaccieBusPercentageBus -
			this.totalLoadLampeggiantiBusPercentageBus;

		this.valuePower.push({ color: '#E5E6E7', value: delta });
		this.valueGreenPower.push({ color: '#E5E6E7', value: deltaLimitGreenPower });
		//	this.valueCalcPower.push({ color: '#E5E6E7', value: deltaLimitGreenNorm });
		this.valueCalcPowerBus.push({ color: '#E5E6E7', value: deltaBus });


		if (delta < 0) {
			this.valuePower = [{ color: 'red', value: 100 }]
			this.statusPower = 2;
		}
		if (deltaLimitGreenPower < 0) {
			this.valueGreenPower = [{ color: 'red', value: 100 }]
			this.statusLimitGreenPower = 2;
			if (this.enableGreenPower) {
				this.showDialog();
			}
		}
		/*if (deltaLimitGreenNorm < 0) {
			this.valueCalcPower = [{ color: 'red', value: 100 }]
			this.statusPowerNorm = 2;
		}*/
		if (deltaBus < 0) {
			this.valueCalcPowerBus = [{ color: 'red', value: 100 }]
			this.statusPowerBus = 2;
		}


		const calcx = this.calcPropLimit(totLimitGreenNorm);

		//------------- limitGreenPower
		//----0.5
		if (this.maxPowerNorm === 0.5 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			this.valueCalcPower = [{ color: 'green', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 1;
		}
		//----0.8
		if (this.maxPowerNorm === 0.8 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			this.valueCalcPower = [{ color: 'green', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 1;
		}
		//----2
		if (this.maxPowerNorm === 2 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			this.valueCalcPower = [{ color: 'green', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 1;
		}
		//----8
		if (this.maxPowerNorm === 8 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			this.valueCalcPower = [{ color: 'green', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 1;
		}
		//----ERROR
		//----0.5<0.8
		if (this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 0.5 && totLimitGreenNorm < 0.8) {
			this.valueCalcPower = [{ color: 'red', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 2;
		}
		//----0.8
		if (this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm === 0.8) {
			this.valueCalcPower = [{ color: 'red', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 2;
		}
		//----0.8<2
		if (this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 0.8 && totLimitGreenNorm < 2) {
			this.valueCalcPower = [{ color: 'red', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 2;
		}
		//----2<8
		if (this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm === 2) {
			this.valueCalcPower = [{ color: 'red', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 2;
		}
		//----2<x>8
		if (this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 2 && totLimitGreenNorm < 8) {

			this.valueCalcPower = [{ color: 'red', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 2;
		}
		//---->8
		if (this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm === 8) {
			this.valueCalcPower = [{ color: 'red', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 2;
		}
		if (this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 8) {
			this.valueCalcPower = [{ color: 'red', value: calcx }, { color: '#E5E6E7', value: 100 - calcx }]
			this.statusPowerNorm = 2;
		}
		//------------- limitGreenPower
		// eslint-disable-next-line max-len


		const doughnutChartLabels = [this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalFotocelluleBus + '): ' + this.totalLoadFotocelluleBusPercentage + '%'];
		doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS') + ' (' + this.totalSelettoriBus + '): ' + this.totalLoadSelettoriBusPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_INTERFACES') + ' (' + this.totalInterfaccieBus + '): ' + this.totalLoadInterfaccieBusPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_FLASHING') + ' (' + this.totalLampeggiantiBus + '): ' + this.totalLoadLampeggiantiBusPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_AVAILABLE') + ': ' + 100 + '%');
		//const deltaChart = 100 - this.totalLoadBusPercentage;
		// eslint-disable-next-line max-len
		const arrayDataSet = [this.totalLoadFotocelluleBusPercentageBus, this.totalLoadSelettoriBusPercentageBus, this.totalLoadInterfaccieBusPercentageBus, this.totalLoadLampeggiantiBusPercentageBus, deltaBus];


		this.totalChart = {
			labels: doughnutChartLabels,
			datasets: [
				{
					data: arrayDataSet,
					backgroundColor: backgroundColorChart,
					borderWidth: 0,
				},
			],
		};
		/*this.totalChart = {
			datasets: [
				{
					data: arrayDataSet,
					backgroundColor: ['orange', 'green', 'blue', 'pink', 'grey'],
					borderWidth: 0,
				},
			],
		};*/
		/* this.doughnutChartData=  [arrayDataSet];
		this.changeLegends();*/
	}

	canAddAlertVisibleDevice(device: AccessoryPower): string {
		/*if (this.enableGreenPower && device.limitGreenPower > 0 && this.maxPowerNorm < 1) {
			return 'text-green-600';
		}
		if (device.power + this.totalPower > this.maxPowerNorm) {
			return 'text-50';
		} if (this.enableGreenPower && device.power + this.totalPower <= this.maxPowerNorm) {
			return 'text-green-600';
		}*/
		return '';
	}

	getColor(val: number): string {
		let totLimitGreenNorm = this.totalLoadBoard + this.totalLoadGateway +
			this.totalLoadSchede + this.totalLoadFotocelluleBus +
			this.totalLoadSelettoriBus + this.totalLoadInterfaccieBus +
			this.totalLoadLampeggiantiBus + this.totalLoadFotocelluleOld +
			this.totalLoadSelettoriOld + this.totalLoadLampeggiantiOld;
		if (this.enableGreenPower) {
			totLimitGreenNorm = this.totalGreenLoadBoard + this.totalGreenLoadGateway +
				this.totalGreenLoadSchede + this.totalGreenLoadFotocelluleBus +
				this.totalGreenLoadSelettoriBus + this.totalGreenLoadInterfaccieBus +
				this.totalGreenLoadLampeggiantiBus + this.totalGreenLoadFotocelluleOld +
				this.totalGreenLoadSelettoriOld + this.totalGreenLoadLampeggiantiOld;
		}
		if (val < this.maxPowerNorm) {
			return 'color: grey;';
		}
		if (val > this.maxPowerNorm) {
			return 'color: black;';
		}
		//----0.5
		if (val === 0.5 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			return 'color: green; font-size: 18px; margin-top: -5px;';
		}
		if (val === 0.5 && this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 0.5) {
			return 'color: red; font-size: 18px; margin-top: -5px;';
		}
		//----0.8
		if (val === 0.8 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			return 'color: green; font-size: 18px; margin-top: -5px;';
		}
		if (val === 0.8 && this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 0.8) {
			return 'color: red; font-size: 18px; margin-top: -5px;';
		}
		//----2
		if (val === 2 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			return 'color: green; font-size: 18px; margin-top: -5px;';
		}
		if (val === 2 && this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 2) {
			return 'color: red; font-size: 18px; margin-top: -5px;';
		}
		//----8
		if (val === 8 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			return 'color: green; font-size: 18px; margin-top: -5px;';
		}
		if (val === 8 && this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 8) {
			return 'color: red; font-size: 18px; margin-top: -5px;';
		}
		return 'color: black;';
	}

	getColorBorder(val: number): string {
		let totLimitGreenNorm = this.totalLoadBoard + this.totalLoadGateway +
			this.totalLoadSchede + this.totalLoadFotocelluleBus +
			this.totalLoadSelettoriBus + this.totalLoadInterfaccieBus +
			this.totalLoadLampeggiantiBus + this.totalLoadFotocelluleOld +
			this.totalLoadSelettoriOld + this.totalLoadLampeggiantiOld;
		if (this.enableGreenPower) {
			totLimitGreenNorm = this.totalGreenLoadBoard + this.totalGreenLoadGateway +
				this.totalGreenLoadSchede + this.totalGreenLoadFotocelluleBus +
				this.totalGreenLoadSelettoriBus + this.totalGreenLoadInterfaccieBus +
				this.totalGreenLoadLampeggiantiBus + this.totalGreenLoadFotocelluleOld +
				this.totalGreenLoadSelettoriOld + this.totalGreenLoadLampeggiantiOld;
		}
		if (val < this.maxPowerNorm) {
			return 'border-left: 1px solid grey;';
		}
		if (val > this.maxPowerNorm) {
			return 'border-left: 1px solid black;';
		}
		//----0.5
		if (val === 0.5 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			return 'border-left: 1px solid green;';
		}
		if (val === 0.5 && this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 0.5) {
			return 'border-left: 1px solid red;';
		}
		//----0.8
		if (val === 0.8 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			return 'border-left: 1px solid green;';
		}
		if (val === 0.8 && this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 0.8) {
			return 'border-left: 1px solid red;';
		}
		//----2
		if (val === 2 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			return 'border-left: 1px solid green;';
		}
		if (val === 2 && this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 2) {
			return 'border-left: 1px solid red;';
		}
		//----8
		if (val === 8 && this.maxPowerNorm - totLimitGreenNorm >= 0) {
			return 'border-left: 1px solid green;';
		}
		if (val === 8 && this.maxPowerNorm - totLimitGreenNorm < 0 && totLimitGreenNorm > 8) {
			return 'border-left: 1px solid red;';
		}
		return 'border-left: 1px solid black;';
	}

	showDialog(): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: 'Limite modulo superato',
			message: 'Il modulo Green power non supporta la potenza inserita',
			//acceptLabel: this.translate.instant('REMOVE'),
			rejectLabel: this.translate.instant('CLOSE'),
			icon: 'pi cm-alert',

			accept: () => {
				this.enableGreenPower = false;
				this.busChange();
			},
			reject: () => {
			}
		});
	}


	showDialog2(): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: 'ACCESSORIO NON COMPATIBILE',
			message: "Per il corretto utilizzo dell'accessorio è necessario disabilitare il modulo green power",
			//acceptLabel: this.translate.instant('REMOVE'),
			rejectLabel: this.translate.instant('CLOSE'),
			icon: 'pi cm-alert',

			accept: () => {
				this.enableGreenPower = false;
				this.busChange();
			},
			reject: () => {
			}
		});
	}


	//----0.5  --->10
	//----0.8  --->25
	//----2  --->45
	//----8  --->70
	//----40  --->100
	calcPropLimit(totLimitGreenNorm: number): number {

		//----0.5
		if (totLimitGreenNorm === 0.5) {
			return 10;
		}
		if (totLimitGreenNorm < 0.5) {
			return Math.floor(totLimitGreenNorm / 10 * 100);
		}
		//----0.8
		if (totLimitGreenNorm === 0.8) {
			return 25;
		}
		if (totLimitGreenNorm < 0.8) {
			return 10 + Math.floor((totLimitGreenNorm - 0.5) / 15 * 100);
		}
		//----2
		if (totLimitGreenNorm === 2) {
			return 45;
		}
		if (totLimitGreenNorm < 2) {
			return 25 + Math.floor((totLimitGreenNorm - 0.8) / 20 * 100);
		}
		//----8
		if (totLimitGreenNorm === 8) {
			return 70;
		}
		if (totLimitGreenNorm < 8) {
			return 45 + Math.floor((totLimitGreenNorm - 2) / 25 * 100);
		}
		//----40
		return 70 + Math.floor((totLimitGreenNorm - 8) / 30 * 100);
	}

	calcCollGraph(): string {
		let cont = 0;
		if (this.maxGateway > 0) {
			cont++;
		}
		if (this.maxSchede > 0) {
			cont++;
		}
		if (this.maxFotocelluleBus > 0 || this.maxLampeggiantiBus > 0 || this.maxInterfaccieBus > 0) {
			cont++;
		}
		if (this.maxSelettoriBus > 0) {
			cont++;
		}
		if (this.maxFotocelluleOld > 0 || this.maxSelettoriOld > 0 || this.maxLampeggiantiOld > 0) {
			cont++;
		}

		if (this.onExtendedMobile()) {
			return '';
		}
		if (!this.overTablet()) {
			return '';
		}

		if (cont < 4) {
			return 'col-offset-4';
		}
		if (cont === 5) {
			return 'col-offset-2';
		}
		return '';
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underMinWidthCol4(): boolean {
		return StandardPageLayout.underMinWidthCol4(this.screenWidth);
	}

	overTablet(): boolean {
		return StandardPageLayout.overTablet(this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-25rem');
	}

	col3Responsive(): string {
		return StandardPageLayout.col3ResponsiveStd(this.screenWidth);
	}
	col2Responsive(): string {
		return StandardPageLayout.col2ResponsiveStd(this.screenWidth);
	}

	col4Responsive(): string {
		return StandardPageLayout.col4ResponsiveStd(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6ResponsiveDesktopTablet(this.screenWidth);
	}

}
